<template>
  <video id="nt-video-player"></video>
</template>

<script>
import Plyr from 'plyr'

export default {
  name: 'nt-player',
  data () {
    return {
      player: null,
      lastCurrentTime: 0,
      timeoutVideoMonitor: null
    }
  },
  props: {
    type: null,
    path: null,
    endVideo: null,
    progress: {
      type: Number,
      default: 0
    },
    updateProgress: null
  },
  mounted () {
    this.player = new Plyr('#nt-video-player', {
      controls: ['play-large', 'play', 'progress', 'current-time', 'duration', 'mute', 'settings', 'airplay', 'fullscreen'],
      invertTime: false,
      autoplay: false
      // muted: true
    })

    this.player.source = {
      type: 'video',
      sources: [
        {
          src: this.path,
          provider: this.type.toLowerCase()
        }
      ]
    }

    if (typeof this.endVideo === 'function') {
      this.player.on('ended', event => {
        if (this.player.fullscreen.active) {
          this.player.fullscreen.exit()
        }
        this.endVideo()
      })
    }

    this.player.on('ready', event => {
      if (typeof this.updateProgress === 'function') {
        this.timeoutVideoMonitor = setTimeout(this.callProgressFunction, 60000)
      }
      if (this.progress < 0.97) {
        setTimeout(() => {
          // set currentTime
          this.player.currentTime = this.player.duration * this.progress
        }, 1000)
      }
    })
  },
  methods: {
    getElementVideo () {
      return document.getElementById('nt-video-player')
    },
    callProgressFunction () {
      if (this.player.currentTime > this.lastCurrentTime) {
        this.lastCurrentTime = this.player.currentTime
        this.updateProgress((this.player.currentTime / this.player.duration))
      }

      if (this.player.currentTime < this.player.duration) {
        this.timeoutVideoMonitor = setTimeout(() => {
          this.callProgressFunction()
        }, 60000)
      }
    }
  },
  beforeDestroy () {
    if (this.timeoutVideoMonitor) {
      clearInterval(this.timeoutVideoMonitor)
    }
    this.player.destroy()
  }
}
</script>
